import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ICustomTheme } from 'interfaces';
import {
  StyledBreadCrumb,
  StyledBreadCrumbsContainer,
  StyledContainer,
  StyledSectionTitle,
} from './styles';

const HistoryHeader = () => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledContainer isMobile={isMobile}>
      <StyledBreadCrumbsContainer separator="›" isMobile={isMobile}>
        <StyledBreadCrumb isMobile={isMobile}>
          {t('challenges.declaration.history.my_account')}
        </StyledBreadCrumb>
        <StyledBreadCrumb isMobile={isMobile} isCurrent>
          {t('challenges.declaration.history.my_declarations')}
        </StyledBreadCrumb>
      </StyledBreadCrumbsContainer>
      <StyledSectionTitle isMobile={isMobile}>
        {t('challenges.declaration.history.my_declarations')}
      </StyledSectionTitle>
    </StyledContainer>
  );
};

export default HistoryHeader;
